import OrganizationApi from 'app/api/OrganizationApi';
import useIsMounted from 'app/hooks/useIsMounted';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input, useToasts } from 'tombac';
import { OrganizationButton, OrganizationPopupForm } from "./OrganizationShared";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.span.withConfig({
  displayName: "OrganizationSapId__Container"
})(["display:inline-block;position:relative;width:7em;text-align:right;"]);
export const OrganizationSapId = _ref => {
  let {
    onChange,
    org
  } = _ref;
  const mounted = useIsMounted();
  const {
    addToast
  } = useToasts();
  const [inputVisible, setInputVisible] = useState(false);
  const [sapId, setSapId] = useState(org.sapId || '');
  const [busy, setBusy] = useState(false);
  useEffect(function onInputVisibleChange() {
    if (inputVisible) setSapId(org.sapId || '');
  }, [inputVisible]);
  const handleSubmit = async event => {
    event.preventDefault();
    setBusy(true);
    try {
      await OrganizationApi.update(org.id, {
        sapId
      });
      setInputVisible(false);
    } catch (error) {
      console.error(error);
      addToast(error?.message || error, 'danger');
    }
    if (mounted.current) {
      setBusy(false);
      onChange && onChange();
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "OrganizationSapId",
    "data-sentry-source-file": "OrganizationSapId.tsx",
    children: [/*#__PURE__*/_jsx(OrganizationButton, {
      onClick: () => setInputVisible(true),
      "data-sentry-element": "OrganizationButton",
      "data-sentry-source-file": "OrganizationSapId.tsx",
      "data-sentry-element": "OrganizationButton",
      children: "Sap ID"
    }), inputVisible && /*#__PURE__*/_jsx(OrganizationPopupForm, {
      onSubmit: handleSubmit,
      children: /*#__PURE__*/_jsx(Input, {
        autoFocus: true,
        disabled: busy,
        onBlur: () => setInputVisible(false),
        onChange: event => setSapId(event.currentTarget.value),
        onKeyUp: event => event.key === 'Escape' && setInputVisible(false),
        value: sapId
      })
    })]
  });
};